export const rolesOptions = [
    { value: "User", name: "User" },
    { value: "Patient", name: "Patient" },
    { value: "User_Patient", name: "User & Patient" },
]

export const genderOptions = [
    { value: "male", name: "Male" },
    { value: "female", name: "Female" },
    { value: "other", name: "Other" },
];

export const weightBelowM = [
    { value: "45", name: "45" },
    { value: "50", name: "50" },
    { value: "55", name: "55" },
];
export const weightAboveM = [
    { value: "75", name: "75" },
    { value: "80", name: "80" },
    { value: "85", name: "85" },
];
export const weightBelowH = [
    { value: "30", name: "30" },
    { value: "35", name: "35" },
    { value: "40", name: "40" },
];
export const weightAboveH = [
    { value: "100", name: "100" },
    { value: "110", name: "110" },
    { value: "120", name: "120" },
];

export const glucoseBelowM = [
    { value: "80", name: "80" },
    { value: "85", name: "85" },
    { value: "90", name: "90" },
];
export const glucoseAboveM = [
    { value: "99", name: "99" },
    { value: "98", name: "98" },
    { value: "97", name: "97" },
];
export const glucoseBelowH = [
    { value: "70", name: "70" },
    { value: "75", name: "75" },
    { value: "80", name: "80" },
];
export const glucoseAboveH = [
    { value: "100", name: "100" },
    { value: "110", name: "110" },
    { value: "125", name: "125" },
];

export const HRBelowM = [
    { value: "90", name: "90" },
    { value: "93", name: "93" },
    { value: "95", name: "95" },
];
export const HRAboveM = [
    { value: "100", name: "100" },
    { value: "103", name: "103" },
    { value: "105", name: "105" },
];
export const HRBelowH = [
    { value: "89", name: "89" },
    { value: "90", name: "90" },
    { value: "91", name: "91" },
];
export const HRAboveH = [
    { value: "110", name: "110" },
    { value: "120", name: "120" },
    { value: "130", name: "130" },
];
export const oxygenBelowM = [
    { value: "90", name: "90" },
    { value: "93", name: "93" },
    { value: "95", name: "95" },
];
export const oxygenAboveM = [
    { value: "100", name: "100" },
    { value: "103", name: "103" },
    { value: "105", name: "105" },
];
export const oxygenBelowH = [
    { value: "89", name: "89" },
    { value: "90", name: "90" },
    { value: "91", name: "91" },
];
export const oxygenAboveH = [
    { value: "110", name: "110" },
    { value: "120", name: "120" },
    { value: "130", name: "130" },
];

export const temperatureBelowM = [
    { value: "97", name: "97" },
    { value: "96", name: "96" },
    { value: "95", name: "95" },
];
export const temperatureAboveM = [
    { value: "99", name: "99" },
    { value: "100", name: "100" },
    { value: "101", name: "101" },
];
export const temperatureBelowH = [
    { value: "95", name: "95" },
    { value: "94", name: "94" },
    { value: "93", name: "93" },
];
export const temperatureAboveH = [
    { value: "100", name: "100" },
    { value: "101", name: "101" },
    { value: "102", name: "102" },
];

export const countryList = [
    { name: "Canada", value: "CA" },
    { name: "United States", value: "US" },
];

export const usregions = [
    {
        name: "Alabama",
        value: "US-AL",
        id: "US-AL",
    },
    {
        name: "Alaska",
        value: "US-AK",
        id: "US-AK",
    },
    {
        name: "American Samoa",
        value: "US-AS",
        id: "US-AS",
    },
    {
        name: "Arizona",
        value: "US-AZ",
        id: "US-AZ",
    },
    {
        name: "Arkansas",
        value: "US-AR",
        id: "US-AR",
    },
    {
        name: "California",
        value: "US-CA",
        id: "US-CA",
    },
    {
        name: "Colorado",
        value: "US-CO",
        id: "US-CO",
    },
    {
        name: "Connecticut",
        value: "US-CT",
        id: "US-CT",
    },
    {
        name: "Delaware",
        value: "US-DE",
        id: "US-DE",
    },
    {
        name: "District of Columbia",
        value: "US-DC",
        id: "US-DC",
    },
    {
        name: "Micronesia",
        value: "US-FM",
        id: "US-FM",
    },
    {
        name: "Florida",
        value: "US-FL",
        id: "US-FL",
    },
    {
        name: "Georgia",
        value: "US-GA",
        id: "US-GA",
    },
    {
        name: "Guam",
        value: "US-GU",
        id: "US-GU",
    },
    {
        name: "Hawaii",
        value: "US-HI",
        id: "US-HI",
    },
    {
        name: "Idaho",
        value: "US-ID",
        id: "US-ID",
    },
    {
        name: "Illinois",
        value: "US-IL",
        id: "US-IL",
    },
    {
        name: "Indiana",
        value: "US-IN",
        id: "US-IN",
    },
    {
        name: "Iowa",
        value: "US-IA",
        id: "US-IA",
    },
    {
        name: "Kansas",
        value: "US-KS",
        id: "US-KS",
    },
    {
        name: "Kentucky",
        value: "US-KY",
        id: "US-KY",
    },
    {
        name: "Louisiana",
        value: "US-LA",
        id: "US-LA",
    },
    {
        name: "Maine",
        value: "US-ME",
        id: "US-ME",
    },
    {
        name: "Marshall Islands",
        value: "US-MH",
        id: "US-MH",
    },
    {
        name: "Maryland",
        value: "US-MD",
        id: "US-MD",
    },
    {
        name: "Massachusetts",
        value: "US-MA",
        id: "US-MA",
    },
    {
        name: "Michigan",
        value: "US-MI",
        id: "US-MI",
    },
    {
        name: "Minnesota",
        value: "US-MN",
        id: "US-MN",
    },
    {
        name: "Mississippi",
        value: "US-MS",
        id: "US-MS",
    },
    {
        name: "Missouri",
        value: "US-MO",
        id: "US-MO",
    },
    {
        name: "Montana",
        value: "US-MT",
        id: "US-MT",
    },
    {
        name: "Nebraska",
        value: "US-NE",
        id: "US-NE",
    },
    {
        name: "Nevada",
        value: "US-NV",
        id: "US-NV",
    },
    {
        name: "New Hampshire",
        value: "US-NH",
        id: "US-NH",
    },
    {
        name: "New Jersey",
        value: "US-NJ",
        id: "US-NJ",
    },
    {
        name: "New Mexico",
        value: "US-NM",
        id: "US-NM",
    },
    {
        name: "New York",
        value: "US-NY",
        id: "US-NY",
    },
    {
        name: "North Carolina",
        value: "US-NC",
        id: "US-NC",
    },
    {
        name: "North Dakota",
        value: "US-ND",
        id: "US-ND",
    },
    {
        name: "Northern Mariana Islands",
        value: "US-MP",
        id: "US-MP",
    },
    {
        name: "Ohio",
        value: "US-OH",
        id: "US-OH",
    },
    {
        name: "Oklahoma",
        value: "US-OK",
        id: "US-OK",
    },
    {
        name: "Oregon",
        value: "US-OR",
        id: "US-OR",
    },
    {
        name: "Palau",
        value: "US-PW",
        id: "US-PW",
    },
    {
        name: "Pennsylvania",
        value: "US-PA",
        id: "US-PA",
    },
    {
        name: "Puerto Rico",
        value: "US-PR",
        id: "US-PR",
    },
    {
        name: "Rhode Island",
        value: "US-RI",
        id: "US-RI",
    },
    {
        name: "South Carolina",
        value: "US-SC",
        id: "US-SC",
    },
    {
        name: "South Dakota",
        value: "US-SD",
        id: "US-SD",
    },
    {
        name: "Tennessee",
        value: "US-TN",
        id: "US-TN",
    },
    {
        name: "Texas",
        value: "US-TX",
        id: "US-TX",
    },
    {
        name: "Utah",
        value: "US-UT",
        id: "US-UT",
    },
    {
        name: "Vermont",
        value: "US-VT",
        id: "US-VT",
    },
    {
        name: "Virgin Islands",
        value: "US-VI",
        id: "US-VI",
    },
    {
        name: "Virginia",
        value: "US-VA",
        id: "US-VA",
    },
    {
        name: "Washington",
        value: "US-WA",
        id: "US-WA",
    },
    {
        name: "West Virginia",
        value: "US-WV",
        id: "US-WV",
    },
    {
        name: "Wisconsin",
        value: "US-WI",
        id: "US-WI",
    },
    {
        name: "Wyoming",
        value: "US-WY",
        id: "US-WY",
    },
];

export const caregions = [
    {
        name: "Alberta",
        value: "CA-AB",
        id: "CA-AB",
    },
    {
        name: "British Columbia",
        value: "CA-BC",
        id: "CA-BC",
    },
    {
        name: "Manitoba",
        value: "CA-MB",
        id: "CA-MB",
    },
    {
        name: "New Brunswick",
        value: "CA-NB",
        id: "CA-NB",
    },
    {
        name: "Newfoundland and Labrador",
        value: "CA-NL",
        id: "CA-NL",
    },
    {
        name: "Northwest Territories",
        value: "CA-NT",
        id: "CA-NT",
    },
    {
        name: "Nova Scotia",
        value: "CA-NS",
        id: "CA-NS",
    },
    {
        name: "Nunavut",
        value: "CA-NU",
        id: "CA-NU",
    },
    {
        name: "Ontario",
        value: "CA-ON",
        id: "CA-ON",
    },
    {
        name: "Prince Edward Island",
        value: "CA-PE",
        id: "CA-PE",
    },
    {
        name: "Quebec",
        value: "CA-QC",
        id: "CA-QC",
    },
    {
        name: "Saskatchewan",
        value: "CA-SK",
        id: "CA-SK",
    },
    {
        name: "Yukon",
        value: "CA-YT",
        id: "CA-YT",
    }
];

// add the field name and space to front of generic message
// this will support multi-language messages
export const validation = { 
    en: {
        regex: "^[\\p{L}\\p{M}\\p{N}\\s.,''\"()\\-\\u2013\\u2014\\/:;?!&+%#@<>\\{\\}\\[\\]`=\\\\_]*$",
        message: "cannot contain invalid characters"
    }
}

/**
 * conditionalValidation is a wrapper function for formik validations to simply the 
 * field level validations.
 * 
 * options is a JSON object which contains all or some of the properties below
 * schema is the field specific schema,
 * validation is the default validation objects for bare minimum validations if any
 * lang is the language setting
 * required puts on optional mandatory fields
 * label is the field label of the field being validated.
 */
export const conditionalValidation = (schema, options) => {
    const validation = options?.validation || null;
    const lang = options?.lang || "en";
    const mandatory = options?.mandatory || false;
    const label = options?.label || "This"
    return schema
        .when([], {
        is: () => !!validation?.[lang]?.regex,
        then: (schema) => schema.test(
            "custom-regex",
            `${label} ${validation?.[lang]?.message}`,
            (value) => {
            if (!value) return true;
            const regex = new RegExp(validation?.[lang]?.regex, 'u');
            return regex.test(value);
            }
        ),
        otherwise: (schema) => schema
        })
        .when([], {
        is: () => mandatory,
        then: (schema) => schema.required(`${label} is a required field`),
        otherwise: (schema) => schema
        });    
}